import React, { memo } from "react";

import { useIsPreviewMode } from "../../hooks/useIsPreviewMode";

import { CommandHistory } from "../command-history";
import { PreviewButton } from "../preview-button";

import { useDefinition } from "../../hooks/useDefinition";
import { useIsTransformMode } from "../../hooks/useIsTransformMode";
import { CloneButton } from "../clone-button";
import { TopToolbar } from "./top-toolbar";
import { SpreadOverviewButton } from "../spread-overview/spread-overview-button";
import { SlideshowPreviewZoomButton } from "../slideshow-preview/slideshow-preview-zoom-button";
import { useHasFinePointer } from "../../hooks/use-has-fine-pointer";
import { useShowDesktopLayout } from "../../hooks/useShowdesktopLayout";
import { EllipseMenu } from "../ellipsis-menu/ellipsis-menu";
import { MenuIds, useMenus } from "../../hooks/useMenus";

function RightTopToolBar() {
	const definition = useDefinition();
	const enableCopySpreads = definition?.product?.copySpreads;

	const showDesktopLayout = useShowDesktopLayout();

	// Show when fine pointer (mouse) is available (don't use touch, when touch + mouse available, also show)
	const showZoomButton = useHasFinePointer();
	return (
		<>
			{enableCopySpreads && <CloneButton />}
			{!showDesktopLayout && <SpreadOverviewButton />}
			{!showDesktopLayout && <PreviewButton />}
			{!showDesktopLayout && showZoomButton && <SlideshowPreviewZoomButton />}
			{!showDesktopLayout && <EllipseMenu />}
		</>
	);
}

export const TopToolbarContainer = memo(function TopToolbarContainer() {
	const { menuId } = useMenus();
	const isEditingText = menuId === MenuIds.TextValue;
	const isInQREditMode = menuId === MenuIds.QrEdit;
	const isInQRAddMode = menuId === MenuIds.QrAdd;

	const [isTransformMode] = useIsTransformMode();
	const [isPreviewMode] = useIsPreviewMode();
	const showDesktopLayout = useShowDesktopLayout();

	// Don't show top toolbar in previewMode or when editing text (save some space on small devices)
	if (isPreviewMode || isEditingText || isInQREditMode || isInQRAddMode) return null;

	// Empty topbar is rendered as to avoid product "jumping"
	if (isTransformMode) {
		return <TopToolbar left={null} right={null} />;
	}

	return (
		<TopToolbar left={!showDesktopLayout && <CommandHistory />} right={<RightTopToolBar />} />
	);
});
